/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Contact_Can_Select_Contact_CodesInputs */

const en_forms_users_settings_contact_can_select_contact_codes = /** @type {(inputs: Forms_Users_Settings_Contact_Can_Select_Contact_CodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codes`)
};

const de_forms_users_settings_contact_can_select_contact_codes = /** @type {(inputs: Forms_Users_Settings_Contact_Can_Select_Contact_CodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer kann Kontaktcodes auswählen`)
};

/**
* | output |
* | --- |
* | "Codes" |
*
* @param {Forms_Users_Settings_Contact_Can_Select_Contact_CodesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_contact_can_select_contact_codes = /** @type {((inputs?: Forms_Users_Settings_Contact_Can_Select_Contact_CodesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Contact_Can_Select_Contact_CodesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_contact_can_select_contact_codes(inputs)
	return de_forms_users_settings_contact_can_select_contact_codes(inputs)
});